@if (hasError()) {
  <!--
    Achado 2 (Important, fix round final): sem `hasError`, uma carga que falhasse chegaria aqui com
    `groups`/`criticalAlerts` vazios (o estado que o container nunca sobrescreve em erro) e caía no
    MESMO ramo vazio abaixo — "Nada para configurar ainda" quando na verdade a requisição falhou.
    Tem precedência sobre `isEmpty()` de propósito: falha nunca se apresenta como ausência real.
  -->
  <lkt-notification-empty
    [title]="errorTitle()"
    [description]="errorDescription()"
    actionLabel="Tentar novamente"
    (action)="onRetry()"
    [dataCy]="errorDataCy()" />
} @else if (isEmpty()) {
  <!--
    Copy NOVA: a API devolve {groups: [], criticalAlerts: []} para professor e
    gestor (o catálogo tem um tipo só, admin-only), e o design não desenhou este
    caso — ver a spec, §6.7, "Estado vazio da vista de preferências é copy
    nova", proposta sujeita a aprovação do PO.
    Reusa o `lkt-notification-empty` da lista: é o mesmo par título+descrição, e
    um segundo estilo de vazio dentro do mesmo painel só divergiria dele. Os
    cabeçalhos de coluna e o rodapé ficam fora — rótulo de coluna sem coluna e
    aviso de alcance sem nada configurado são ruído.
  -->
  <lkt-notification-empty
    [title]="emptyTitle()"
    [description]="emptyDescription()"
    [dataCy]="emptyDataCy()" />
} @else {
  <!--
    Primeira célula vazia de propósito: alinha os rótulos com as colunas dos
    interruptores e deixa a coluna de texto sem cabeçalho
    (css/notificacoes.css:224-234). Duas colunas de canal, percorridas da MESMA
    lista que as linhas percorrem — é isso que garante que o rótulo intitule o
    interruptor que está debaixo dele.
  -->
  <div class="nt-prefs__cab">
    <span></span>
    @for (column of channels(); track column.id) {
      <span class="nt-prefs__cab-label">{{ column.label }}</span>
    }
  </div>

  <!--
    CA 07: `track row.toggleKey` aqui é requisito de comportamento, não
    otimização. O container atualiza a lista de forma otimista a cada toque, e
    sem a chave estável o @for destruiria e recriaria a linha — quem navega por
    teclado perderia o foco do interruptor que acabou de acionar. Por isso
    também nada nesta vista é derivado por identidade de objeto ou por índice.
  -->
  @for (row of groups(); track row.toggleKey) {
    <div class="nt-pref">
      <div class="nt-pref__txt">
        <span class="nt-pref__nome">{{ row.label }}</span>
        @if (row.description) {
          <span class="nt-pref__desc">{{ row.description }}</span>
        }
      </div>
      @for (column of channels(); track column.id) {
        <div class="nt-pref__col">
          <lkt-switch
            size="small"
            [checked]="isChannelEnabled(row, column)"
            [dataCy]="channelDataCy(row, column)"
            [ariaLabel]="channelAriaLabel(row, column)"
            (checkedChange)="onToggle(row, column, $event)" />
        </div>
      }
    </div>
  }

  @if (criticalAlerts().length > 0) {
    <!--
      Subtítulo obrigatório: sem ele os alertas se misturam aos grupos e a tela
      perde a noção de que ali se configura outra coisa
      (js/notificacoes.js:630-632). A marcação da linha é a mesma dos grupos —
      repetir o bloco é mais barato de ler que um ng-template com
      ngTemplateOutlet, e as duas chamam o mesmo handler. A linha de alerta
      crítico tem as MESMAS duas colunas, sem exceção estrutural: no protótipo
      nenhuma chave é travada em canal nenhum (js/notificacoes.js:308-311).
    -->
    <div class="nt-prefs__sec">{{ criticalTitle() }}</div>

    @for (row of criticalAlerts(); track row.toggleKey) {
      <div class="nt-pref">
        <div class="nt-pref__txt">
          <span class="nt-pref__nome">{{ row.label }}</span>
          @if (row.description) {
            <span class="nt-pref__desc">{{ row.description }}</span>
          }
        </div>
        @for (column of channels(); track column.id) {
          <div class="nt-pref__col">
            <lkt-switch
              size="small"
              [checked]="isChannelEnabled(row, column)"
              [dataCy]="channelDataCy(row, column)"
              [ariaLabel]="channelAriaLabel(row, column)"
              (checkedChange)="onToggle(row, column, $event)" />
          </div>
        }
      </div>
    }
  }

  <!-- Texto estático, não link: o rodapé desta vista só informa o alcance da
       configuração (js/notificacoes.js:665-667). -->
  <div class="nt-prefs__foot">
    <span class="nt-prefs__rodape">{{ footerNote() }}</span>
  </div>
}
